import { data } from "./data";

// export const backendUrl = "http://localhost:5003";
export const backendUrl = data?.backendUrl;
